<template>
    <v-app>
        <v-main>
            <v-dialog v-model="showPopup" :width="400">
                <div class="popup-body">
                    <div class="popup-msg">
                        {{ $t('closePopupFirstMsg') }}
                    </div>
                    <div class="popup-msgTwo">
                        {{ $t('closePopupSecondMsg') }}
                    </div>
                    <div class="popup-close">
                        <button @click="showPopup = false" class="close-btn">
                            Close
                        </button>
                    </div>

                </div>
            </v-dialog>
            <router-view />
        </v-main>
    </v-app>
</template>

<script>

export default {
    name: 'App',

    data: () => ({
        showPopup: false,
    }),
    mounted() {
        const savedLang = localStorage.getItem('lang');
        if (savedLang) {
            this.$i18n.locale = savedLang;
        }
        document.title = this.$t('applicationTitle')
        this.showPopup = true;
    },
    watch: {
    // Watch for changes in the language (when `this.$i18n.locale` changes)
    '$i18n.locale'(newLocale) {
      this.setTitle();
    }
  },
  methods: {
    // Method to update the document title
    setTitle() {
      document.title = this.$t('applicationTitle');  // Translate and set title dynamically
    },
  },
}
</script>

<style scoped>
@font-face {
    font-family: 'Inter';
    src: url('@/assets/fonts/Inter_28pt-Regular.ttf');
}

@font-face {
    font-family: 'CobblerSans';
    src: url('@/assets/fonts/CobblerSans.ttf');
}



* {
    font-family: 'Inter';
}

.popup-body {
    background-color: #0073CC;
    color: #FFF;
    padding: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-family: 'CobblerSans';
}

.popup-msg {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    font-size: 16px;
    text-align: center;
    font-family: 'CobblerSans';
}

.popup-msgTwo {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    font-size: 16px;
    text-align: center;
    font-family: 'CobblerSans';
}

.popup-close {
    display: flex;
    justify-content: center;
}

.close-btn {
    background: #00b2de;
    color: #FFF;
    padding: 0.5em 2em;
    border-radius: 16px;
    font-weight: 500;
    font-size: 16px;
    width: 60%;
}
</style>
